import { render, staticRenderFns } from "./AppEnv.vue?vue&type=template&id=64a167be&scoped=true&"
import script from "./AppEnv.vue?vue&type=script&lang=js&"
export * from "./AppEnv.vue?vue&type=script&lang=js&"
import style0 from "./AppEnv.vue?vue&type=style&index=0&id=64a167be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a167be",
  null
  
)

export default component.exports